import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import ThirdPartyAdmin from 'model/organizations/thirdPartyAdmin'
import CarePod from 'model/organizations/carePod'
import { isNil, pathOr } from 'ramda'

class Organization extends ActiveRecord {
  // named after the GraphQL scheme
  constructor(init) {
    super(init)
    // console.log('> Organization constructor -', init)
    if (isNil(init)) return undefined
    this._care_pod = new CarePod(init.care_pod)
    this._member_count = init.member_count
    this._full_name = init.full_name
    this._last_claims_updated_at = init.last_claims_updated_at
    this._name = init.name
    this._notes = init.notes
    this._third_party_admin = new ThirdPartyAdmin(init.third_party_admin)
    this._tpa_group = init.tpa_group
    this._spend_data_source = init.spend_data_source
  }

  static shape = {
    id: PropTypes.string.isRequired,
    care_pod: PropTypes.instanceOf(CarePod),
    member_count: PropTypes.number,
    full_name: PropTypes.string,
    last_claims_updated_at: PropTypes.string,
    name: PropTypes.string,
    notes: PropTypes.string,
    third_party_admin: PropTypes.instanceOf(ThirdPartyAdmin),
    tpa_group: PropTypes.string,
    spend_data_source: PropTypes.string
  }

  // Getters for class fields
  get care_pod() {
    return this._care_pod
  }

  get member_count() {
    return this._member_count
  }

  get full_name() {
    return this._full_name || ''
  }

  get last_claims_updated_at() {
    return this._last_claims_updated_at
  }

  get name() {
    return this._name || ''
  }

  get notes() {
    return this._notes || ''
  }

  get third_party_admin() {
    return this._third_party_admin
  }

  get tpa_group() {
    return this._tpa_group || ''
  }

  get spend_data_source() {
    return this._spend_data_source || ''
  }

  // Calculable
  get getFullName() {
    const orgName = pathOr('', ['name'], this)
    const orgAbr = pathOr('', ['third_party_admin', 'abbr'], this)
    let orgFullName = orgName
    if (orgAbr) orgFullName = `${orgAbr} - ${orgName}`

    return orgFullName || 'N/A'
  }

  get getTpaAbbrFromOrganization() {
    return pathOr('', ['third_party_admin', 'abbr'], this)
  }

  get getTpaNameFromOrganization() {
    return pathOr('', ['third_party_admin', 'name'], this)
  }

  get getOrganizationStructure() {
    return {
      orgTpaAbr: this.getTpaAbbrFromOrganization,
      orgTpaGroupName: this.tpa_group
    }
  }

  get getOrganizationFullName() {
    // equivalent for utils/tables/getOrganizationName
    const orgAbr = this.getTpaAbbrFromOrganization
    let orgFullName = this.name
    if (orgAbr) orgFullName = `${orgAbr} - ${this.name}`

    return orgFullName || 'N/A'
  }

  get getSelectOption() {
    return {
      label: this.getOrganizationFullName,
      value: this.id
    }
  }
}

export default Organization
